export default __webpack_public_path__ + "static/media/OSmile.3ddd4471.svg";